import React from "react";
import { motion } from "framer-motion";
import { useTypedTranslation } from "@/i18n/useTypedTranslation";

interface SplashScreenProps {
  onComplete: () => void;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const { t } = useTypedTranslation();

  React.useEffect(() => {
    const timer = setTimeout(onComplete, 2200);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <motion.div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background"
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      <motion.span
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4, ease: [0.34, 1.56, 0.64, 1] }}
        className="text-5xl mb-4"
      >
        🐾
      </motion.span>

      <motion.h1
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="text-[32px] font-[800] tracking-[2px] text-foreground"
      >
        PETERNITY
      </motion.h1>

      <motion.div
        initial={{ width: 0, opacity: 0 }}
        animate={{ width: 32, opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.4 }}
        className="h-px my-3 bg-muted-foreground/30"
      />

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.5 }}
        className="text-sm font-normal italic text-muted-foreground"
      >
        {t('splash.slogan')}
      </motion.p>
    </motion.div>
  );
};
